import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
// import { persistStore, persistReducer } from 'redux-persist';

import { persistStore } from "redux-persist";

// import storage from 'redux-persist/lib/storage' // defaults to localStorage for web and AsyncStorage for react-native
import rootReducer from "./reducers";

const initialState = {};
const middleware = [thunk];

// const persistConfig = {
//     key: 'root',
//     storage,
//   }

// const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = createStore(
	rootReducer,
	initialState,
	compose(
		applyMiddleware(...middleware)
		// window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
	)
);

export const persistor = persistStore(store);



// WEBPACK FOOTER //
// ./src/v3/store.js